import { ReportListItemType } from '../Types/Types'

/**
 * Report selection actions that needs to be done in old reporting portal window.
 * @param reportItem Report properties.
 */
export const handleRptPortalReportItemSelection = (reportItem: ReportListItemType): void => {
    const windowRef = window as Window & typeof globalThis & { m_pRptPortal: CRptPortal }
    const reportPortalSelectMenuItemFunc = windowRef.m_pRptPortal.getSelectedReportFunc()

    reportPortalSelectMenuItemFunc(reportItem)
}

/**
 * Report deletion actions that needs to be done in old reporting portal window.
 * @param checkedReportItemID
 */
export const handleRptPortalDeleteReport = (checkedReportItemID: string): void => {
    const windowRef = window as Window & typeof globalThis & { m_pRptPortal: CRptPortal }
    const rptPortalDeleteReportFunc = windowRef.m_pRptPortal.getDeleteReport()

    rptPortalDeleteReportFunc(checkedReportItemID)
}

/**
 * Resolves selected report.
 * @return Currently selected report.
 */
export const getSelectedReport = (): CActiveRpt | undefined => {
    const widnowRef = window as Window & typeof globalThis & { m_pRptPortal: CRptPortal }
    const activeReport = widnowRef.m_pRptPortal?.getRptSelected()

    return activeReport
}

/**
 * Callback that needs to be called after Update / Rename operations so that old reporting portal window is updated if this report is in active report list.
 *
 * @param reportID ID of the report to update in Report Portal active report list.
 * @param newDescription Description of the report that will be set (used like a name in active report tabs).
 * @param durationFilterSummaryText Tooltip that appears on hover over active report list tab. If undefined is provided, the durationFilterSummaryText is not updated.
 */
export const handleReportUpdateRenameActiveRptDescription = (
    reportID: string,
    newDescription: string,
    durationFilterSummaryText: string | undefined
): void => {
    const windowRef = window as Window & typeof globalThis & { m_pRptPortal: CRptPortal }
    const rptRenameOrUpdateUpdateActiveReportFunc = windowRef.m_pRptPortal.RptRenameOrUpdateUpdateActiveReport

    rptRenameOrUpdateUpdateActiveReportFunc(reportID, newDescription, durationFilterSummaryText, true)
}
